export const savingsOverviewNn = {
    savingsOverview: {
        savingsDistributionSummary: {
            ariaLabel: 'Oversikt over sparing',
            loadingLabel: 'Lastar oversikt over sparing',
            totalLabel: 'Total sparing',
            savingsLabel: 'Sparekonto',
            fundsLabel: 'Fond',
            sharesLabel: 'Aksjar',
            errorHeading: 'Kunne ikkje hente oversikt over sparing',
            errorText: 'Vi klarte ikkje å hente sparebeløpet ditt. Prøv igjen seinare.',
        },
        showing: 'Viser {} av {}',
        total: 'Totalt: {}',
    },
    savingsAccounts: {
        accountTrackingLabel: 'Gå til sparekonto',
        heading: 'Sparekonto',
        listLabel: 'Sparekontoar',
        loadingLabel: 'Lastar sparekontoar',
        fetchError: 'Kunne ikkje hente sparekontoar. Prøv igjen seinare.',
        emptyStateTitle: 'Sparing på sparekonto',
        emptyStateDescription: 'Spar trygt på konto og ha pengane tilgjengelege når du treng dei. Opprett ein sparekonto på få minutt.',
        emptyStateCreateSavingsAccount: 'Opprett sparekonto',
        interestsLoadingLabel: 'Lastar opptente renter',
        interestsEarnedFirstPart: 'Visste du at du har opptent ',
        interestsEarnedLastPart: ' i renter på kontoar? Rentene blir utbetalte på slutten av året.',
        interestsEarnedLastPartPenni: ' i renter på kontoar? Rentene blir utbetalte månadleg.',
    },
    savingsFunds: {
        fundTrackingLabel: 'Gå til fond: {}',
        heading: 'Fond',
        loadingLabel: 'Lastar fond',
        fetchError: 'Kunne ikkje hente fond. Prøv igjen seinare.',
        seeAllFunds: 'Gå til fondsside',
        hasPendingOrder: 'Ordre på veg',
        noFunds: {
            title: 'Sparing i fond',
            descriptionLineOne: 'Har du eit sparemål som ligg litt fram i tid?',
            descriptionLineTwo: 'Fond kan hjelpe sparepengane dine til å vekse over tid.',
            startFundSaving: 'Lær meir om fondssparing',
            fundGuide: 'Finn fond som passar for deg',
            savingsGrowthCalculator: 'Sjå kva sparinga di kan vekse til',
        },
    },
    authorizedSavingsAccounts: {
        accountTrackingLabel: 'Gå til sparekonto',
        heading: 'Sparekontoar du har tilgang til',
        loadingLabel: 'Lastar delte sparekontoar',
        fetchError: 'Kunne ikkje hente delte sparekontoar. Prøv igjen seinare.',
    },
    authorizedFundAccounts: {
        accountTrackingLabel: 'Gå til fondskonto',
        heading: 'Fondskontoar du har tilgang til',
        loadingLabel: 'Lastar aksjesparekontoar du har tilgang til',
        fetchError: 'Kunne ikkje hente aksjesparekontoar du har tilgang til. Prøv igjen seinare.',
    },
    savingsAgreementsAccounts: {
        seeExistingAgreements: 'Sjå spareavtalar sparekonto',
        startNewAgreement: 'Start spareavtale sparekonto',
        title: 'Fast overføring til konto',
        monthlyAmount: '{} per månad',
        nextPaymentDate: 'Neste trekk den {}',
        startSavingTitle: 'Fast sparing til sparekonto',
        startSavingDescription: 'Set av eit fast beløp kvar månad, så slepp du å hugse det sjølv.',
        loadingLabel: 'Lastar faste overføringar til konto',
        fetchError: 'Kunne ikkje hente faste overføringar til konto. Prøv igjen seinare.',
    },
    savingsAgreementsFunds: {
        seeExistingAgreements: 'Sjå spareavtalar i fond',
        startNewAgreement: 'Start spareavtale i fond',
        title: 'Spareavtale i fond',
        monthlyAmount: '{} per månad',
        nextPaymentDate: 'Neste trekk den {}',
        startSavingTitle: 'Spareavtale i fond',
        startSavingDescription: 'Set av eit fast beløp kvar månad, så slepp du å hugse det sjølv.',
        loadingLabel: 'Lastar spareavtalar i fond',
        fetchError: 'Kunne ikkje hente spareavtalar i fond. Prøv igjen seinare.',
    },
    savingsAgreementsMicrosaving: {
        seeExistingAgreements: 'Sjå mikrosparavtalar',
        startNewAgreement: 'Start mikrosparing',
        title: 'Mikrosparing',
        oneAgreement: 'Du har {} mikrosparavtale',
        multipleAgreements: 'Du har {} mikrosparavtalar',
        description: 'Sjå dine avtalar',
        loadingLabel: 'Lastar mikrosparavtalar',
        fetchError: 'Kunne ikkje hente mikrosparavtalar. Prøv igjen seinare.',
        startTitle: 'Mikrosparing',
        startDescription: 'Spar automatisk kvar gong du bruker kortet. Kom i gang med mikrosparing.',
    },
    savingsEncouragement: {
        loadingLabel: 'Lastar sparetips',
        texts: {
            NO_SAVINGS_PRODUCTS: 'Kom i gang med sparing! Finn ei sparing som passar for deg.',
            ACCOUNT_NO_FUNDS: 'Skal du spare over lengre tid? Sjå om fond kan passe for delar av sparinga di.',
            ACCOUNT_FUNDS_NO_AGREEMENTS: 'Gjer sparinga enklare med ei spareavtale. Vel eit beløp som blir sett av automatisk kvar månad.',
            ACCOUNT_FUNDS_AGREEMENTS: 'Bra jobba - du sparer jamt og trutt! Sjølv eit lite beløp kan vekse seg stort over tid.',
        },
        actions: {
            FIND_SAVINGS_PRODUCT: 'Finn ei sparing',
            VIEW_FUNDS: 'Sjå sparing i fond',
            START_SAVING_AGREEMENT: 'Start fast sparing',
            INCREASE_SAVINGS_AMOUNT: 'Auk sparebeløp',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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